<template>
  <Card class="trip-faq">
    <h1 class="trip-faq__header">Frequently asked questions</h1>
    <div class="trip-faq__items">
      <TripFaqItem
        v-for="(faq, index) in faqs"
        :key="index"
        :q="faq.question"
        :a="parseMarkdown(faq.answer)"
        :open="false"
        :last="false"
      />
    </div>
  </Card>
</template>

<script setup lang="ts">
import Card from '@/components/Theme2/Card.vue'
import TripFaqItem from '@/components/TripFaqItem.vue'
import faqs from 'lib/data/publish_trip_faqs.yml'
import { parseMarkdown } from '@/utils'
</script>

<style lang="scss" scoped>
.trip-faq {
  .trip-faq__header {
    font-size: $text-xl;
  }

  .trip-faq__items {
    @include flex-column($spacing-4);

    :deep(.faq-item-section) {
      .wrapper {
        background-color: $white;
        padding: 0;
      }
    }
  }
}
</style>
